export const defaultLocale = 'en';

export const locales = ['en', 'ar', 'es', 'de', 'zh', 'he'];
export const rtlLocales = ['ar', 'he'];

// need to customize later
export const languageNames = {
  en: 'English',
  fr: 'français',
  pl: 'polski',
};
